import { tap, switchMap, Observable, of, takeUntil, Subject } from 'rxjs';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';

import { AuthService } from './auth/services/auth.service';

import { UserInfoDto } from '@sociuu/interfaces';

declare global {
  interface Window {
    HubSpotConversations: any;
    hsConversationsSettings: any;
  }
}

@Component({
  selector: 'sociuu-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit, OnDestroy {
  public currentUser: UserInfoDto;
  public destroyed$ = new Subject<void>();

  constructor(private authService: AuthService, private activatedRoute: ActivatedRoute) {
  }

  public ngOnInit(): void {
    this.routeObserver();
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private routeObserver(): void {
    this.activatedRoute.data
    .pipe(
      takeUntil(this.destroyed$),
      tap((data: Data): void => {
        this.authService.isSociuuhub = data?.isSociuuhub;
      }),
      switchMap((data: Data) => this.handleNavigationEvent(data))
    ).subscribe()
  }

  private handleNavigationEvent(data: Data): Observable<any> {
    return of(data)
      .pipe(
        switchMap((): Observable<UserInfoDto> => this.authService.currentUser),
        tap((user: UserInfoDto) => this.currentUser = user),
        switchMap((user: UserInfoDto): Observable<string> => user ? this.authService.checkHubspotToken() : of(null)),
        tap((hubspotToken: string): void => hubspotToken && this.handleHubspotTokenAndUser(this.currentUser, hubspotToken)),
        takeUntil(this.destroyed$),
      )
  }

  private handleHubspotTokenAndUser(user: UserInfoDto, hubspotToken?: string) {
    if (user && hubspotToken) this.loadHubspotWidget(hubspotToken);
  }

  private loadHubspotWidget(token: string): void {
    // const tokenData: ITokenData = JSON.parse(atob(token.split('.')[1]));
    // window.hsConversationsSettings = {
    //   identificationToken: token,
    //   identificationEmail: tokenData.sub,
    // };
    window.HubSpotConversations?.widget.load();
  }
}
